import * as axios from 'axios';
import _ from 'lodash';
import { buildQuery, buildQueryParams, formatDate, addDate } from '../../common/utils.js';
import * as AppActions from '../app/AppActions.js';

export const LOADING_WAIT_LIST = '/appointment/loading_wait_list';
export const LOAD_WAIT_LIST = '/appointment/load_wait_list';
export const LOAD_BLOCKAGES = '/appointment/load_blockages';
export const CLEAR_ESTIMATIONS = '/appointment/clear_estimations';
export const LOAD_ESTIMATIONS = '/appointment/load_estimations';
export const CLEAR_CLIENT_ESTIMATIONS = '/appointment/clear_client_estimations';
export const LOAD_CLIENT_ESTIMATIONS = '/appointment/load_client_estimations';
export const SET_STAFF_ESTIMATIONS_LOADING =
  '/appointment/set_staff_estimations_loading';
export const CLEAR_STAFF_ESTIMATIONS = '/appointment/clear_staff_estimations';
export const LOAD_STAFF_ESTIMATIONS = '/appointment/load_staff_estimations';
export const CLEAR_APPOINTMENTS = '/appointment/clear_appointments';
export const SET_APPOINTMENTS = '/appointment/set_appointments';
export const CLEAR_BOOKINGS = '/appointment/clear_bookings';
export const LOAD_BOOKINGS = '/appointment/load_bookings';

const uuidv4 = require('uuid/v4');
const moment = require('moment');

export function getWaitingList(locationId) {
  return function(dispatch) {
    dispatch({
      type: LOADING_WAIT_LIST,
    });

    return axios
      .get(
        `/my_client/appointments.json?statuses=waiting&location_id=${locationId}&sort_field=sort_order&sort_order=asc&for_waitlist=true`
      )
      .then(res => {
        dispatch({ type: LOAD_WAIT_LIST, data: res.data });
        return Promise.resolve(true);
      })
      .catch(error => {
        console.log(error);
        // eslint-disable-next-line
        Raven.captureException(error);
        return Promise.resolve(false);
      });
  };
}

export function getBookings(locationId, clientId) {
  return function(dispatch) {
    dispatch({ type: CLEAR_BOOKINGS });

    return axios
      .get(
        `/my_client/appointments.json?statuses=booked,confirmed,auto_booked&location_id=${locationId}&client_id=${clientId}&sort_field=sort_order&sort_order=asc&start_date=${moment().format(
          'YYYY-MM-DD'
        )}&end_date=${moment().format('YYYY-MM-DD')} 23:59:59`
      )
      .then(res => {
        const bookings = res.data.appointments.filter(
          a =>
            !a.checked_in &&
            ['booked', 'confirmed', 'auto_booked'].indexOf(a.status) > -1
        );
        dispatch({ type: LOAD_BOOKINGS, data: bookings });

        if (bookings.length > 0) {
          return Promise.resolve(true);
        } else {
          return Promise.resolve(false);
        }
      })
      .catch(error => {
        console.log(error);
        // eslint-disable-next-line
        Raven.captureException(error);
        return Promise.resolve(false);
      });
  };
}

export function getBlockages(locationId, date = new Date()) {
  const query = buildQuery({
    location_id: locationId,
    start_date: formatDate(date),
    end_date: formatDate(addDate(date, 1)),
  });

  return function(dispatch) {
    return axios
      .get(`/my_client/blockages.json?${query}`)
      .then(res => {
        dispatch({ type: LOAD_BLOCKAGES, data: res.data });
        return Promise.resolve(true);
      })
      .catch(error => {
        console.log(error);
        // eslint-disable-next-line
        Raven.captureException(error);
        return Promise.resolve(false);
      });
  };
}

export function getEstimations(
  clearOldData,
  locationId,
  employee,
  variations = [],
  clientId,
  childId,
  forEmployees = []
) {
  const query = buildQuery({
    location_id: locationId,
    kiosk_only: true,
    employee_id: employee && employee.id,
    variation_ids:
      !variations || !variations.length ? undefined : variations.join(','),
    for_employee_ids:
      !forEmployees || !forEmployees.length
        ? undefined
        : forEmployees.join(','),
  });

  return function(dispatch) {
    if (clearOldData) {
      dispatch({ type: CLEAR_ESTIMATIONS });
    }

    return axios
      .get(`/api/mkp/v1/estimations.json?${query}`)
      .then(res => {
        dispatch({ type: LOAD_ESTIMATIONS, data: res.data });
        return Promise.resolve(true);
      })
      .catch(error => {
        console.log(error);
        // eslint-disable-next-line
        Raven.captureException(error);
        dispatch(AppActions.setError('error_notification.failed_to_load_estimations'));
        return Promise.resolve(false);
      });
  };
}

export function getClientEstimations(clearOldData, location, sequenceData) {
  const queryData = {
    location_id: location.id,
    kiosk_only: true,
  };

  if (sequenceData && sequenceData.length > 0) {
    sequenceData.forEach((s, i) => {
      queryData[`sequences[${i}][employee_id]`] = s.employee_id;
      queryData[`sequences[${i}][variation_ids]`] = s.variation_ids;
      queryData[`sequences[${i}][for_employee_ids]`] = s.for_employee_ids;
      queryData[`sequences[${i}][child_id]`] = s.child_id;
      queryData[`sequences[${i}][client_id]`] = s.client_id;
    });
  }

  const query = buildQuery(queryData);

  return function(dispatch) {
    if (clearOldData) {
      dispatch({ type: CLEAR_CLIENT_ESTIMATIONS });
    }

    return axios
      .get(`/api/mkp/v1/estimations.json?${query}`)
      .then(res => {
        dispatch({
          type: LOAD_CLIENT_ESTIMATIONS,
          data: res.data,
        });
        return Promise.resolve(true);
      })
      .catch(error => {
        console.log(error);
        // eslint-disable-next-line
        Raven.captureException(error);
        return Promise.resolve(false);
      });
  };
}

export function getStaffEstimations(clearOldData, location, sequenceDataArray) {
  const queryData = {
    location_id: location.id,
    kiosk_only: true,
  };

  return function(dispatch) {
    dispatch({
      type: SET_STAFF_ESTIMATIONS_LOADING,
    });

    if (clearOldData) {
      dispatch({ type: CLEAR_STAFF_ESTIMATIONS });
    }

    const promises = []

    sequenceDataArray.forEach((sequenceData) => {
      if (sequenceData && sequenceData.length > 0) {
        sequenceData.forEach((s, i) => {
          queryData[`sequences[${i}][employee_id]`] = s.employee_id;
          queryData[`sequences[${i}][variation_ids]`] = s.variation_ids;
          queryData[`sequences[${i}][for_employee_ids]`] = s.for_employee_ids;
          queryData[`sequences[${i}][child_id]`] = s.child_id;
          queryData[`sequences[${i}][client_id]`] = s.client_id;
        });

        const query = buildQuery(queryData);

        promises.push(
          axios
            .get(`/api/mkp/v1/estimations.json?${query}`)
        );
      }
    })

    return Promise.all(promises)
      .then(resultsArray => {
        if (resultsArray?.length) {
          const combinedResults = {
            estimations: [...(resultsArray[0].data.estimations), ...(resultsArray[1].data.estimations)]
          }
  
          dispatch({
            type: LOAD_STAFF_ESTIMATIONS,
            data: combinedResults,
          });
        }
        return Promise.resolve(true);
      })
      .catch(error => {
        console.log(error);
        // eslint-disable-next-line
        Raven.captureException(error);
        return Promise.resolve(false);
      })
  };
}

const uniqueKeyFor = sv => {
  if (!!sv.parentVariationId) {
    return `${sv.variationId}${sv.parentVariationId}`;
  } else {
    return `${sv.variationId}`;
  }
};

function getAppointmentCreateData(
  locationId,
  clientId,
  childId,
  selectedVariations,
  variations,
  employeeId,
  bookRealAppointments,
  beginAt,
  endAt,
  price,
  employeeRequested,
  durations,
  resourcesBySegmentTemplateIdsMap = {},
  durationsBySegmentTemplateIdsMap = {}
) {
  let SVOrder = [];
  const slotVariationsById = {}

  // Find sort order for backend variations
  selectedVariations.forEach(sv => {
    if (!sv.parentVariationId) {
      SVOrder.push(uniqueKeyFor(sv)); // Variation goes first
      SVOrder = SVOrder.concat(
        selectedVariations
          .filter(svv => svv.parentVariationId === sv.variationId)
          .map(svv => uniqueKeyFor(svv))
      ); // It's addons come after.
    }
  });

  // create hash and add uuid to all SVs that are not add-ons
  selectedVariations.forEach(sv => {
    slotVariationsById[sv.variationId] = sv
    if (!sv.parentVariationId && !sv.uuid) {
      sv.uuid = uuidv4()
    }
  })

  // set uuid for addons based on parent service uuid
  selectedVariations.forEach(sv => {
    const parentVariationUuid = slotVariationsById[sv.parentVariationId]?.uuid
    if (sv.parentVariationId && !sv.parentVariationUuid && parentVariationUuid) {
      sv.parentVariationUuid = parentVariationUuid
    }
  })

  // Sort selected by expected backend order
  let selectedVariationsSorted = selectedVariations.slice().sort((v1, v2) => {
    let indA = SVOrder.indexOf(uniqueKeyFor(v1));
    let indB = SVOrder.indexOf(uniqueKeyFor(v2));

    if (indA < indB) {
      return -1;
    }
    if (indB > indA) {
      return 1;
    }
    return 0;
  });

  const data = {
    appointment: {
      display_color_ids: [],
      color_code_type: null,
      begin_at: beginAt,
      end_at: endAt,
      client_id: clientId,
      child_id: childId,
      employee_id: employeeId,
      location_id: locationId,
      employee_requested: !!employeeRequested,
      travel_to_customer: false,
      slot_variations: selectedVariationsSorted.map(sv => {
        // eslint-disable-next-line
        let v = variations.find(v => v.id == sv.variationId);

        let parentId = !!sv.parentVariationId ? sv.parentVariationId : null
        if (sv.parentVariationUuid) {
          parentId = sv.parentVariationUuid
        }

        const getSegmentTemplateDuration = (st) => {
          if (durationsBySegmentTemplateIdsMap[st.id]) {
            return durationsBySegmentTemplateIdsMap[st.id] || 0
          }
          if (!st.duration && durations) {
            const durationTemplate = durations.find(duration => {
              if (employeeId) {
                // eslint-disable-next-line
                return duration.employee_id == employeeId && duration.segment_template_id == st.id
              }
              // eslint-disable-next-line
              return duration.segment_template_id == st.id
            })
            if (durationTemplate) {
              return durationTemplate.time_span
            } else {
              return 0
            }
          }
          return st.duration
        }

        return {
          variation_id: v.id,
          disable_package: null,
          parent_id: parentId,
          uuid: sv.uuid || uuidv4(),
          price: price != null
              ? price[v.id]
              : undefined,
          segments: v.segment_templates.map(st => {
            return {
              kind: st.kind,
              position: st.position,
              duration: getSegmentTemplateDuration(st),
              segment_template_id: st.id,
              segment_resources: resourcesBySegmentTemplateIdsMap[st.id] || [],
            }
          }),
        };
      }),
      recurring_appointment: {},
    },
    ignore_conflicts: true,
    from_kiosk: true,
  };

  if (!bookRealAppointments) {
    data.waiting = true;
  }

  return data;
}

export function clearAppointments() {
  return function(dispatch) {
    dispatch({ type: CLEAR_APPOINTMENTS })
  }
}

export function createAppointment({
    locationId,
    clientId,
    childId,
    selectedVariations,
    variations,
    employeeId,
    bookRealAppointments,
    beginAt,
    endAt,
    price,
    employeeRequested,
    durations,
    resourcesBySegmentTemplateIdsMap,
    durationsBySegmentTemplateIdsMap
}) {
  return function(dispatch) {
    dispatch({ type: CLEAR_APPOINTMENTS });

    return axios
      .post(
        `/my_client/appointments.json`,
        getAppointmentCreateData(
          locationId,
          clientId,
          childId,
          selectedVariations,
          variations,
          employeeId,
          bookRealAppointments,
          beginAt,
          endAt,
          price,
          employeeRequested,
          durations,
          resourcesBySegmentTemplateIdsMap,
          durationsBySegmentTemplateIdsMap
        )
      )
      .then(res => {
        const appointmentId = res.data.appointment.id;

        if (bookRealAppointments) {
          dispatch(confirmAppointment(appointmentId));
        } else {
          dispatch({ type: SET_APPOINTMENTS, data: res.data });
        }
        return Promise.resolve(true);
      })
      .catch(error => {
        console.log(error);
        // eslint-disable-next-line
        Raven.captureException(error);
        dispatch(AppActions.setError('Something went wrong. Please try again.'));
        return Promise.resolve(false);
      });
  };
}

export function confirmAppointment(appointmentId) {
  return function(dispatch) {
    return axios
      .post(`/my_client/appointments/${appointmentId}/client_checked_in.json`)
      .then(res => {
        dispatch({ type: SET_APPOINTMENTS, data: res.data });
        return Promise.resolve(true);
      })
      .catch(error => {
        console.log(error);
        // eslint-disable-next-line
        Raven.captureException(error);
        dispatch(AppActions.setError('error_notification.something_went_wrong'));
        return Promise.resolve(false);
      });
  };
}

export function generateSequence(
  clientId,
  childId,
  clientVariations,
  clientEmployee,
  employees
) {
  const selectedVariations = clientVariations
    .filter(cv => cv.clientId === clientId && cv.childId === childId)
    .map(cv => cv.variationId);

  const employee = clientEmployee.filter(
    ce => ce.clientId === clientId && ce.childId === childId
  )[0];

  let employeeIdParam = null
  if (employee && employee?.employeeId)
    employeeIdParam = _.get(employee, 'estimation.real_employee_id', employee.employeeId)

  return {
    employee_id: employeeIdParam,
    variation_ids: selectedVariations.join(','),
    child_id: childId,
    client_id: clientId,
    for_employee_ids: employees.map(e => e.id),
  };
}

export async function getPrice(locationId, variationId, clientId, employeeId) {
  try {
    const res = await axios.get(
      `/my_client/appointments/default_price.json?client_id=${clientId}&location_id=${locationId}&employee_id=${employeeId}&variation_id=${variationId}`
    );
    if (res.data && res.data.price) {
      return res.data.price;
    } else {
      return 0;
    }
  } catch (error) {
    // eslint-disable-next-line
    Raven.captureException(error);
  }
}

export async function checkForConflicts({
  locationId,
  clientId,
  childId,
  selectedVariations,
  variations,
  employeeId,
  bookRealAppointments,
  beginAt,
  endAt,
  price,
  employeeRequested,
  durations,
  resourcesBySegmentTemplateIdsMap,
  durationsBySegmentTemplateIdsMap
}) {
    const { appointment } = getAppointmentCreateData(
      locationId,
      clientId,
      childId,
      selectedVariations,
      variations,
      employeeId,
      bookRealAppointments,
      beginAt,
      endAt,
      price,
      employeeRequested,
      durations,
      resourcesBySegmentTemplateIdsMap,
      durationsBySegmentTemplateIdsMap
    )

    let options = {
        employee_id: appointment.employee_id,
        location_id: appointment.location_id
    };

    options.begin_at = appointment.begin_at;
    options.end_at = appointment.end_at;
    options.appointment_id = appointment.id;
    options.variation_ids = appointment.slot_variations.map(sv => sv.variation_id);
    options.segments = (appointment.slot_variations || []).flatMap(sv => {
      let filteredSegments = sv.segments.filter(segment => segment.duration)
      return filteredSegments
    });

    // cleanup undefined values
    for (let key in options) {
        if (!options[key]) {
            delete options[key];
        }
    }

    if (options.begin_at && options.segments && options.variation_ids.every(vid => vid)) {
      const query = buildQueryParams(options);
      return axios.get(`/my_client/appointments/conflicts.json?${query}`)
      .then((conflicts = {}) => {
        const {
          appointments,
          blockages,
          employee_ids_outside_working_hours,
          outside_working_hours
        } = conflicts?.data;

        if (appointments?.length) {
          return true
        }

        if (blockages?.length) {
          return true
        }

        if (employee_ids_outside_working_hours?.find(e => e === employeeId)) {
          return true
        }

        if (outside_working_hours) {
          return true
        }

        return false
      })
      .catch((error) => {
        console.error('Error fetching conflicts', error)
        // eslint-disable-next-line
        Raven.captureException(error);
        return false
      })
    }
  }

export async function checkForConflictsOpenTimes({
  locationId,
  clientId,
  childId,
  selectedVariations,
  variations,
  employeeId,
  bookRealAppointments,
  beginAt,
  endAt,
  price,
  employeeRequested,
  durations,
  resourcesBySegmentTemplateIdsMap,
  durationsBySegmentTemplateIdsMap
}) {
    const { appointment } = getAppointmentCreateData(
      locationId,
      clientId,
      childId,
      selectedVariations,
      variations,
      employeeId,
      bookRealAppointments,
      beginAt,
      endAt,
      price,
      employeeRequested,
      durations,
      resourcesBySegmentTemplateIdsMap,
      durationsBySegmentTemplateIdsMap
    )

    let options = {
        employee_id: appointment.employee_id,
        location_id: appointment.location_id
    };

    options.begin_at = appointment.begin_at;
    options.end_at = appointment.end_at;
    options.appointment_id = appointment.id;
    options.variation_ids = appointment.slot_variations.map(sv => sv.variation_id);

    // cleanup undefined values
    for (let key in options) {
        if (!options[key]) {
            delete options[key];
        }
    }

    if (options.begin_at && options.variation_ids.every(vid => vid)) {
      const query = buildQueryParams(options);
      return axios.get(`/my_client/appointments/conflicts.json?${query}`)
      .then((conflicts = {}) => {
        const {
          opening_available,
        } = conflicts?.data;

        if (!opening_available) {
          return true
        }

        return false
      })
      .catch((error) => {
        console.error('Error fetching conflicts for Open Times', error)
        // eslint-disable-next-line
        Raven.captureException(error);
        return false
      })
    }
  }
